import React from 'react';
import MDTLogo from 'src/assets/images/MedtronicWhite.svg';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import EngineeringwhiteDesktop from 'src/assets/images/EngineeringwhiteDesktop.svg';
import Logout2 from 'src/assets/images/Logout2.svg';
import Button from 'src/common/refactoredComponents/button/Button';
import {
    Container,
    ImageContainer,
    Image,
    Wrapper,
    Header,
    Logo,
    ErrorTitle,
    ErrorMessage,
    ErrorDetails,
    ButtonText,
} from './SsoErrorCommon.styled';
    
const InactiveUserPage = ({ errorMessage }) => {
    const { instance } = useMsal();
    const { t } = useTranslation();

    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        instance.logoutRedirect({
            postLogoutRedirectUri: window.location.origin,
        });
    };

    return (
        <Container>
            <ImageContainer>
                <Image src={EngineeringwhiteDesktop} alt={t('ssoError.inactiveUserImageAlt')} />
            </ImageContainer>
            <Wrapper>
                <Header>
                    <Logo src={MDTLogo} alt={t('ssoError.medtronicLogoAlt')} />
                </Header>
                <ErrorTitle>{t('ssoError.inactiveUserTitle')}</ErrorTitle>
                <ErrorMessage>
                    {errorMessage}
                </ErrorMessage>
                <ErrorDetails>
                    {t('ssoError.inactiveUserMessage')}
                </ErrorDetails>
                <Button
                    id={'inactiveuser-logout-button'}
                    show={true}
                    width={'119px'}
                    height={'36px'}
                    margin={'20px 0 0 0'}
                    backgroundColor={'#140f4b'}
                    color={'#ffffff'}
                    border={'1px solid #ffffff'}
                    clicked={handleLogout}
                >
                    <div style={{ margin: '5px 10px 0 5px', cursor: 'pointer' }}>
                        <img src={Logout2} alt={t('ssoError.logoutIconAlt')} />
                    </div>
                    <ButtonText>{t('ssoError.logoutButton')}</ButtonText>
                </Button>
            </Wrapper>
        </Container>
    );
};

export default InactiveUserPage;
